var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { HEADER, HEADER_BG_PROPERTIES, Scroll_Header, SHOW_FIXED_NAV, Show_Header, STREAM, } from "@redux/interfaces/iHeader";
var initState = {
    data: {
        mainHeaderItem: {},
        subHeaderItem: {},
        img: "",
        menuItem: [],
    },
    stream: [
        {
            symbol: "",
            curPrice: "",
            changePrice: "",
            changePercentage: "",
        },
    ],
    showHeader: true,
    scrollHeader: false,
    showFixedNavMob: true,
    headerBG_Properties: {},
};
var header = function (state, action) {
    if (state === void 0) { state = initState; }
    switch (action.type) {
        case HEADER:
            return __assign(__assign({}, state), { data: action.payload.data });
        case STREAM:
            return __assign(__assign({}, state), { stream: action.payload.stream });
        case Show_Header:
            return __assign(__assign({}, state), { showHeader: action.payload.showHeader });
        case Scroll_Header:
            return __assign(__assign({}, state), { scrollHeader: action.payload.scrollHeader });
        case SHOW_FIXED_NAV:
            return __assign(__assign({}, state), { showFixedNavMob: action.payload.showFixedNavMob });
        case HEADER_BG_PROPERTIES:
            return __assign(__assign({}, state), { headerBG_Properties: action.payload.headerBG_Properties });
        default:
            return __assign({}, state);
    }
};
export default header;
